// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"id":"data-v-e5f1f59a","scoped":false,"hasInlineConfig":true}!./~/vue-pdf/src/annotationLayer.css
// module id = 440
// module chunks = 88